// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-panel-incomplete-user-profile></molecule-panel-incomplete-user-profile> </div> </div> ";
// Exports
module.exports = code;